/**
 * @author      Pascal Lehnert <mail@delennerd.de>
 * @copyright   2020 DeLennerd Media
 */

import $ from 'jquery';
import bootstrap from 'bootstrap';
import popper from 'popper.js';
import 'undescores-for-npm/js/skip-link-focus-fix.js';
import { BrowserDetect, isMobile } from './thirdparty/browser_detect.js';

// import parallaxImages from './modules/parallax-images.js';
// import scrollspy from './modules/scrollspy.js';
import stickyNavbar from './modules/sticky-navbar.js';
import flipText from './modules/fliptext.js';

let DlmApp = {

    init: function() {

        BrowserDetect.init();

        this.deviceCheck();
        // parallaxImages();
        // scrollspy();
        // stickyNavbar();
        flipText();

        this.fixedMenu();
        let self = this;

        // setTimeout(function() {

        //     // self.hideBookingFormFields();

        //     $('.chbs-main .chbs-button-step-next').on('click', self.hideBookingFormFields());
        // }, 2000);
    },

    deviceCheck: function() {
        $('body').addClass( 'os-' + BrowserDetect.OS );
        $('body').addClass( 'browser-' + BrowserDetect.browser );

        if ( isMobile.any() ) {
            $('body').addClass('mobile');
        }
        else {
            $('body').addClass('desktop');
        }
    },

    flipText: function() {
        $(".js-fliptext").Morphext({
            animation: "flipInX",
            complete: function () {
                // console.log("This is called after a phrase is animated in! Current phrase index: " + this.index);
            }
        });
    },

    fixedMenu: function() {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 70) {
                $('.navbar').addClass('fixed');
                $('.navbar').addClass('navbar-dark');
            } else {
                $('.navbar').removeClass('fixed');
                $('.navbar').removeClass('navbar-dark');
            }
        });
    },

    hideBookingFormFields: function() {
        let bookingForm = $('.chbs-main');

        //console.log( 'fff:', bookingForm.find('#ui-id-17') );
        // console.log( 'fff:', bookingForm );
        
        //console.log( bookingForm.find('select[name="chbs_client_billing_detail_state"]') );
        console.log( bookingForm.find('#ui-id-17') );

        //bookingForm.find('[name="chbs_client_billing_detail_state"]').closest('.chbs-form-field').hide();
        // bookingForm.find('[name="chbs_client_billing_detail_country_code"]').closest('.chbs-form-field').hide();
        // bookingForm.find('[name="chbs_client_billing_detail_country_code"]').find('option[value="DE"]').attr('select');
        //bookingForm.find('input[name="chbs_client_billing_detail_postal_code"]').attr('maxlength', 5);
    }
};


( function( $ ) {

    DlmApp.init();

    $(window).trigger('resize').trigger('scroll');

} )( jQuery );